"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignOutButton = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var emotion_1 = require("emotion");
var appLanguageBase_1 = require("../../language/appLanguageBase");
var appStyleClasses_1 = require("../../styles/appStyleClasses");
var react_redux_1 = require("react-redux");
var description = 'SignOutButton';
var SignOutButton = function (_a) {
    var _b = _a.styles, styles = _b === void 0 ? '' : _b, onClick = _a.onClick, _c = _a.useHollowButtonStyles, useHollowButtonStyles = _c === void 0 ? true : _c;
    var dispatch = (0, react_redux_1.useDispatch)();
    return (React.createElement("button", { type: "button", className: "SignOutButton ".concat((0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n        ", "\n\n        &:first-letter {\n          text-transform: capitalize;\n        }\n        ", "\n      "], ["\n        ", "\n\n        &:first-letter {\n          text-transform: capitalize;\n        }\n        ", "\n      "])), useHollowButtonStyles ? appStyleClasses_1.appStyleClasses.hollowButtonStyles() : '', styles)), onClick: function (e) {
            dispatch({
                type: 'SIGN_OUT_REQUEST_ACTION',
                description: description,
            });
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        } }, (0, appLanguageBase_1.appLanguageBase)().signOut));
};
exports.SignOutButton = SignOutButton;
var templateObject_1;
